import React from "react";
import Button from "@mui/material/Button";

function ErrorFallback({ error, errorInfo, onReset }) {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center p-6 bg-[var(--bg)]">
      <div className="max-w-xl text-center">
        <h2 className="text-2xl font-semibold mb-2">Something went wrong</h2>
        <p className="text-sm text-gray-600 mb-4">
          An unexpected error occurred. Parts of the app may be unavailable.
        </p>
        <div className="mb-4">
          <Button variant="contained" color="primary" onClick={onReset}>
            Try again
          </Button>
        </div>
        <details className="text-left text-xs text-gray-500">
          <summary className="cursor-pointer">Error details</summary>
          <pre className="whitespace-pre-wrap break-words">
            {error?.toString()}
            {errorInfo?.componentStack}
          </pre>
        </details>
      </div>
    </div>
  );
}

export default ErrorFallback;
